import React from 'react';
import Table from 'app/components/common/Table';
import { numberWithCommas } from 'app/libs/number';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import classNames from 'classnames/bind';
import styles from './PaymentServiceDetail.module.scss';

const cx = classNames.bind(styles);

function PaymentServiceDetail({ yearMonth, usageByProductionData = undefined, adjustSummaryData = undefined }) {
	const ua = useSsrUserAgent();
	// 반응형 스타일
	const colWidth = ua().isPc ? '198px' : '140px';
	const isEmpty = !usageByProductionData || usageByProductionData.length === 0;
	const isNoShowEmpty = !adjustSummaryData?.noShowCount || adjustSummaryData?.noShowCount === 0;

	return (
		<>
			<div className={cx('box_detail_service')}>
				<h3 className={cx('tit_cont')}>상품별 이용내역</h3>
				<Table
					type="row"
					caption="상품별 이용내역"
					tableAlign="right"
				>
					<colgroup>
						<col style={{ width: colWidth }} />
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th>제휴상품</th>
							<th className={cx('cellalign_right')}>이용대수</th>
							<th className={cx('cellalign_right')}>이용금액</th>
						</tr>
					</thead>
					<tbody>
						{isEmpty && isNoShowEmpty && (
							<tr>
								<td>-</td>
								<td className={cx('cellalign_right')}>-</td>
								<td className={cx('cellalign_right')}>-</td>
							</tr>
						)}
						{usageByProductionData?.map((item) => (
							<tr key={`${yearMonth}_${item.prodNm}`}>
								<td>{item.prodNm}</td>
								<td className={cx('cellalign_right')}>{`${item.usageCount}대`}</td>
								<td className={cx('cellalign_right')}>{`${numberWithCommas(item.paymentAmount)}원`}</td>
							</tr>
						))}
						{!isNoShowEmpty && (
							<tr key="no_show">
								<td>No-Show</td>
								<td className={cx('cellalign_right')}>{adjustSummaryData?.noShowCount}대</td>
								<td className={cx('cellalign_right')}>{`${numberWithCommas(adjustSummaryData?.noShowAmount)}원`}</td>
							</tr>
						)}
					</tbody>
				</Table>
			</div>
		</>
	);
}

export default PaymentServiceDetail;
